import dompurify from "dompurify"

export const webps = {}

export async function fetchInsertSvg(url: string, el: HTMLElement) {
  const res = await fetch(url)
  if (!res.ok) return
  const svgText = dompurify.sanitize(await res.text(), {
    USE_PROFILES: { svg: true, svgFilters: true },
  })
  el.innerHTML = svgText
}
